// frontend/src/homepage/meshConstants.js
//
// The primitives shared ACROSS the mesh's code-split boundary, and nothing else.
//
// MeshCanvas is mounted through React.lazy so that meshEngine.js - the single
// biggest thing on the homepage, with nothing readable depending on it - stays
// out of the chunk the hero needs before it can paint. That split only holds
// if no eager module imports from MeshCanvas.js or meshEngine.js: webpack
// follows a static `import { X } from "./MeshCanvas"` into the eager graph
// whatever X is, so one string constant pulled from there drags the whole
// engine along (it did - review finding 2, 2026-09-03).
//
// So every constant that both sides need lives HERE, in a module that imports
// nothing. The hero side (HeroLive, IgniteTag, useHeroCycle) and the engine
// side (MeshCanvas, meshEngine) both read it; neither reads the other.
// `src/__tests__/meshSplitBoundary.test.js` is the guard.

/** The event the mesh fires on the window when a pulse reaches a node. */
export const IGNITE_EVENT = "mesh:ignite";
/** The event a consumer fires to ask the mesh for the nearest node to a point. */
export const IGNITE_NEAR_EVENT = "mesh:igniteNear";
/** The width at which the page switches to its mobile motion budget. */
export const MOBILE_MAX_WIDTH = 900;
